import './App.css';
import ApplicationRoutes from "./Routes";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MODULES, getModuleFromUrl } from "./redux/appModule/appModuleSlice";
import { applyModuleBranding } from "./utils/moduleBranding";
import { TOAST_AUTOCLOSE, TOAST_POSITION } from "./utils/toastConfig";

function App() {
  // Set the browser-tab name + icon from the URL (query param → hostname), so each
  // module's URL shows its own branding. Falls back to CoWork on a neutral URL.
  useEffect(() => {
    applyModuleBranding(getModuleFromUrl() || MODULES.COWORK);
  }, []);

  return (
    <>
      <ApplicationRoutes />

      {/* THE ToastContainer — the only one in the app.
          Every page used to mount its own, which meant a toast was rendered once
          per mounted container (duplicates), unmounting the page killed its
          toasts mid-flight, and a container nested inside a page could be
          painted under that page's popup/overlay. One container at the root
          fixes all three: it lives above every route and every overlay.

          pauseOnFocusLoss is off on purpose — with it on, toasts fired while the
          window was not focused (another tab, devtools, an OS window) froze
          their timers and then all drained at once on refocus, which is exactly
          the "delayed, stacked up, then all at once" behaviour. */}
      <ToastContainer
        position={TOAST_POSITION}
        autoClose={TOAST_AUTOCLOSE}
        newestOnTop
        limit={3}
        pauseOnFocusLoss={false}
        closeOnClick
        draggable
        style={{ zIndex: 999999 }}
        toastStyle={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}
      />
    </>
  );
}

export default App;
